import React, { Component } from 'react'

import { withRouter } from 'router/index'

import FormGroup from 'components/FormGroup'
import Button from 'components/Button'
import ProjectRemover from 'components/ProjectRemover'

class ProjectDangerZoneUI extends Component {
  state = {
    isRemoverOpen: false
  }

  handleOpenRemover = () => {
    this.setState({ isRemoverOpen: true })
  }

  handleCloseRemover = () => {
    this.setState({ isRemoverOpen: false })
  }

  handleRemoved = () => {
    this.props.history.push('/projects')
  }

  render() {
    return (
      <React.Fragment>
        <FormGroup>
          <Button
            variant="danger"
            onClick={this.handleOpenRemover}
          >
            Remove
          </Button>
        </FormGroup>

        {this.state.isRemoverOpen &&
          <ProjectRemover
            project={this.props.project}

            onRemoved={this.handleRemoved}
            onCancel={this.handleCloseRemover}
          />
        }
      </React.Fragment>
    )
  }
}

export default withRouter(ProjectDangerZoneUI)



// WEBPACK FOOTER //
// ./src/components/ProjectDangerZoneUI/index.js